export const favoriteTextTransform = (value) => {
  if (value === 'Accept') {
    return 'Connected';
  } else if (value === 'Reject') {
    return 'Rejected';
  } else {
    return value;
  }
};
